import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Radio } from '../../../../../common/html/radio'
import classes from '../index.module.scss'

const ViewBy = ({ viewByList, viewBy, setValue }) => {
  const onChangeViewBy = (value) => {
    setValue('setting.viewBy', value)
  }

  return (
    <Element className={classes.viewBy} style={{ background: '#F3F3F3' }}>
      <div className={classes.label}>
        <Translate value="financialAnalysis.VIEW_BY" />
      </div>
      <div className={`dFlex ${classes.radios}`}>
        {viewByList.map((value, index) => {
          return (
            <Radio
              key={value}
              mlTitle={5}
              appendStyle={{
                marginLeft: index !== 0 ? '38px' : '0px',
              }}
              title={`dynamicReport.${value}`}
              value={value}
              activeValue={viewBy}
              onChange={onChangeViewBy}
              isI18n
              titleStyle={{ whiteSpace: 'nowrap' }}
            />
          )
        })}
      </div>
    </Element>
  )
}

ViewBy.propTypes = {
  viewByList: PropTypes.array.isRequired,
  viewBy: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
}

export default ViewBy
